export const selectToken = (state) => state.user.token;

export const selectUser = (state) => state.user.profile;

export const selectHoldings = (state) => state.user.portfolio;

export const selectBtcInfo = (state) => state.user.btcInfo;

export const selectEthInfo = (state) => state.user.ethInfo;

export const selectLtcInfo = (state) => state.user.ltcInfo;

export const selectXrpInfo = (state) => state.user.xrpInfo;

export const selectAaplInfo = (state) => state.user.aaplInfo;

export const selectAbnbInfo = (state) => state.user.abnbInfo;

export const selectAmdInfo = (state) => state.user.amdInfo;

export const selectAmznInfo = (state) => state.user.amznInfo;
